import { useEffect, useState } from "react"
import supportedLanguages from "../../Helpers/supportedLanguages"
import SupportedLanguagesPropTypes from "../../PropTypes/SupportedLanguagePropTypes";
import { useTranslation } from "react-i18next";
import { Dropdown, DropdownButton } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { SET_LANGUAGE } from "../../Actions/Types";
import { useSelector } from "react-redux";
import { StoreProptypes } from "../../PropTypes/StoreProptypes";


// component to render language switcher
const LanguageSwitcher = () => {    

    const { i18n } = useTranslation();

    const dispatch = useDispatch();

    const { lang } = useSelector((store: StoreProptypes) => store);

    const [flag, setFlag] = useState(false);

    const [activeLang, setActiveLang] = useState<SupportedLanguagesPropTypes[]>();

    // function to change language
    const changeLanguage = (
        langCode: string // language code
    ) => {
        i18n.changeLanguage(langCode);
        if (langCode !== lang) {
            dispatch({ type: SET_LANGUAGE, payload: langCode });
        }
    }

    // function to handle language change
    const handleActiveLang = () => {
        const currentLang = i18n.language;

        // find language object
        const temp = supportedLanguages.filter(language => {
            if (language.slug === currentLang) {
                return true
            }
        });

        // check if language is found
        if (temp.length) {
            setActiveLang(temp);
        }
    }

    useEffect(() => {
        handleActiveLang();
    }, [i18n.language])

    useEffect(() => {
        // check if language exist and first time execution flag is false
        if (lang && !flag) {
            setFlag(true);
            changeLanguage(lang);
        }
    }, [lang])


    return (
        <div className='language-switch-wrapper'>

            <Dropdown>
                <Dropdown.Toggle
                    aria-label="Select language"
                    className="btn btn-secondary"
                >
                    {activeLang ? activeLang[0].slug.toUpperCase() : "EN"}
                </Dropdown.Toggle>

                <Dropdown.Menu align="end">
                    {supportedLanguages.map(language => (
                    <Dropdown.Item
                        key={language.id}
                        onClick={() => changeLanguage(language.slug)}
                    >
                        <span className="langcode" aioa-read-skip="true" aria-hidden="true">{language.slug.indexOf("-") > -1 ? language.slug.slice(-2) : language.slug}</span>
                        <span>{language.name}</span>
                    </Dropdown.Item>
                    ))}
                </Dropdown.Menu>
                </Dropdown>


        </div>
    )
}

export default LanguageSwitcher